import poster from './poster';
import product from './product';
import selector from './selector';
import releasePosters from './release-posters';
import printPosters from './print-posters';
import templateImages from './template-images';

import state from './state';
import getters from './getters';
import mutations from './mutations';

import actions from './actions';

export default {
  modules: {
    selector,
    poster,
    product,
    releasePosters,
    printPosters,
    templateImages,
  },
  getters,
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/index.js